<div
    ngbDropdown
    #localizationConfirmDropdown="ngbDropdown"
    class="dropdown"
    [open]="showPopup()"
    [autoClose]="false"
>
    <div class="d-none" ngbDropdownToggle></div>
    <div ngbDropdownMenu class="dropdown-menu">
        <div class="dropdown-wrapper p-3">
            <div class="close" (click)="close()">
                <app-icon [type]="'ThinCross'"></app-icon>
            </div>

            <div class="content">
                <span class="text">Is {{ organizationName }} your local station?</span>
                <span class="buttons">
                    <app-button (click)="close()" class="pl-sm-3 pr-3">Yes</app-button>
                    <app-button (click)="openLocalizationChangeModal()" class="border-btn"
                        >No, change</app-button
                    >
                </span>
            </div>
        </div>

        <div class="bigBg"></div>
    </div>
</div>
